import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, Typography } from '@mui/material';

const UserTrainingsPerDayAndMonthTable = ({ data }) => {
  return (
    <Paper style={{ maxHeight: '400px', overflowY: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        <FormattedMessage id='userTracking.perDayAndMonth.label.title' defaultMessage='Trainings Per Day and Month' />
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><FormattedMessage id='userTracking.perDayAndMonth.table.day' defaultMessage='Day' /></TableCell>
            <TableCell><FormattedMessage id='userTracking.perDayAndMonth.table.month' defaultMessage='Month' /></TableCell>
            <TableCell><FormattedMessage id='userTracking.perDayAndMonth.table.yearMonth' defaultMessage='Year-Month-Day' /></TableCell>
            <TableCell><FormattedMessage id='userTracking.perDayAndMonth.table.userCount' defaultMessage='Training Count' /></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item.yearMonthDay}>
              <TableCell>{item.day}</TableCell>
              <TableCell>{item.month}</TableCell>
              <TableCell>{item.yearMonthDay}</TableCell>
              <TableCell>{item.trainingCount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

UserTrainingsPerDayAndMonthTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string,
      month: PropTypes.string,
      yearMonthDay: PropTypes.string,
      trainingCount: PropTypes.number,
    })
  ),
};

export { UserTrainingsPerDayAndMonthTable };